import React, { useEffect } from 'react';
import { useAccountContext } from '../../AccountContext';
import { toFormattedDate } from '../../../../utilities/FormatHelpers';
import { useCurrentBillingPeriod, useGetBillingPeriods } from '@app/sdk';
import { Button } from 'semantic-ui-react';
import { useGenerateStatementFile } from '../../../../sdk/cus/UseGenerateStatementFile';
import { useStatementSubmissions } from '../../../../sdk/cus/useStatementSubmissions';
import { Loading } from '../../../tms/components/LoadingWrapper';

export default function BillingPeriodStatementSelector() {
  const { accountId, setSelectedBillingPeriod, selectedBillingPeriod } = useAccountContext();
  const { data: billingPeriods } = useGetBillingPeriods(accountId);
  const { data: currentBillingPeriod } = useCurrentBillingPeriod(accountId);
  useEffect(() => {
    setSelectedBillingPeriod(currentBillingPeriod);
  }, [currentBillingPeriod, setSelectedBillingPeriod]);

  const { mutate: generateStatementFile, isPending } = useGenerateStatementFile();

  return (
    <div className="ui">
      {billingPeriods?.slice(0, -1).map((bp) => (
        <div key={bp.billingPeriodId} className={'ui buttons'} style={{ marginRight: '5px' }}>
          <Button
            key={bp.billingPeriodId}
            className="ui button"
            icon="file alternate"
            labelPosition="left"
            active={selectedBillingPeriod?.billingPeriodId === bp?.billingPeriodId}
            content={
              <div>
                Statement {bp?.billingPeriodId}{' '}
                <div className="ui grey sub header">
                  {toFormattedDate(bp?.startDate)} - {toFormattedDate(bp?.endDate)}
                </div>
              </div>
            }
            onClick={() => setSelectedBillingPeriod(bp)}></Button>
          <Button onClick={() => generateStatementFile(bp?.endDate)} className={'ui icon button'}>
            <i className="upload icon"></i>
            <Loading loading={isPending}></Loading>
            {!isPending && <SubmissionCountView date={bp?.endDate}></SubmissionCountView>}
          </Button>
        </div>
      ))}
    </div>
  );
}

function SubmissionCountView({ date }: { date: string }) {
  const { data: submissions } = useStatementSubmissions(date);
  return (
    <div>
      <i className={`icon ${submissions?.ids?.length > 0 ? 'check green' : 'times red'}`}></i>
    </div>
  );
}
